/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetYoutubeCategoriesQueryResponse, SocialExportGetYoutubeCategoriesPathParams, SocialExportGetYoutubeCategories400, SocialExportGetYoutubeCategories401, SocialExportGetYoutubeCategories403, SocialExportGetYoutubeCategories404 } from "../models/SocialExportGetYoutubeCategories";

export function getSocialExportGetYoutubeCategoriesUrl(connectionId: SocialExportGetYoutubeCategoriesPathParams["connectionId"]) {
  const res = { method: 'GET', url: `/social-export/v1/platforms/youtube/${connectionId}/categories` as const }
  return res
}

/**
 * @description Returns available YouTube video categories based on the client country code. Returns an empty array when the client has no country code.
 * @summary Get YouTube video categories for a connection
 * {@link /social-export/v1/platforms/youtube/:connectionId/categories}
 */
export async function socialExportGetYoutubeCategories(connectionId: SocialExportGetYoutubeCategoriesPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetYoutubeCategoriesQueryResponse, ResponseErrorConfig<SocialExportGetYoutubeCategories400 | SocialExportGetYoutubeCategories401 | SocialExportGetYoutubeCategories403 | SocialExportGetYoutubeCategories404>, unknown>({ method : "GET", url : getSocialExportGetYoutubeCategoriesUrl(connectionId).url.toString(), ... requestConfig })
  return res.data
}